<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-box">
      <button class="close" @click="$emit('close')">×</button>

      <h2>{{ $t("message.localguide_model_title") }}</h2>
      <p class="subtitle">
        {{ $t("message.localguide_model_description") }}
      </p>

      <!-- SUCCESS MESSAGE -->
      <p v-if="successMessage" style="color: green; text-align:center;">
        {{ successMessage }}
      </p>

      <!-- ERROR MESSAGE -->
      <p v-if="errorMessage" style="color: red; text-align:center;">
        {{ errorMessage }}
      </p>

      <form @submit.prevent="submitForm">
        <label>{{ $t("message.full_name") }}</label>
        <input type="text" v-model="form.full_name" :placeholder="$t('message.full_name')"  required />

        <label>{{ $t("message.email_id") }}</label>
        <input type="email" v-model="form.email_id" :placeholder="$t('message.email_id')" required />

        <label>{{ $t("message.phone_number") }}</label>
        <input type="text" v-model="form.phone_number" placeholder="+52 (xx) xxxx-xxxx" required />

        <label>{{ $t("message.city") }}</label>
        <input type="text" v-model="form.city" :placeholder="$t('message.city')" required />

        <button type="submit" class="submit-btn" :disabled="loading">
          {{ loading ? $t("message.sending") : $t("message.get_early_access") }}
        </button>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { apiCall } from "@/services/api";

const form = ref({
  full_name: "",
  email_id: "",
  phone_number: "",
  city: ""
});

const loading = ref(false);
const successMessage = ref("");
const errorMessage = ref("");

const submitForm = async () => {
  loading.value = true;
  successMessage.value = "";
  errorMessage.value = "";

  const result = await apiCall(
    "https://api.farrther.com/admin/catalogs/mail/websitenotificationlocalguide",
    "POST",
    form.value
  );

  loading.value = false;

  if (result.ok) {
    console.log("Guide API Response:", result.data);

    successMessage.value = "Guide registration successful! 🎉";

    // Clear form
    form.value = {
      full_name: "",
      email_id: "",
      phone_number: "",
      city: ""
    };

    // Optional: auto close modal after 2 seconds
    setTimeout(() => {
      successMessage.value = "";
    }, 5000);

  } else {
    errorMessage.value =
      result.data.message || "Something went wrong!";
  }
};
</script>


<style scoped>
/* Overlay */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Modal box */
.modal-box {
  background: #ffffff;
  color: #000000;
  width: 100%;
  max-width: 500px;
  padding: 40px;
  border-radius: 16px;
  position: relative;
  z-index: 10000;
}

/* Close button */
.close {
  position: absolute;
  top: 16px;
  right: 18px;
  font-size: 26px;
  background: none;
  border: none;
  cursor: pointer;
}

/* Text */
h2 {
  text-align: center;
  margin-bottom: 8px;
}

.subtitle {
  text-align: center;
  color: #555;
  margin-bottom: 24px;
}

/* Form */
form label {
  display: block;
  margin-bottom: 6px;
}

form input {
  width: 100%;
  padding: 12px;
  margin-bottom: 16px;
  border-radius: 8px;
  border: 1px solid #ccc;
}

.submit-btn {
  width: 100%;
  padding: 14px;
  background: #163c36;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  cursor: pointer;
}
</style>
